import { render, staticRenderFns } from "./claimIndemnity.vue?vue&type=template&id=4d028889&scoped=true&"
import script from "./claimIndemnity.vue?vue&type=script&lang=js&"
export * from "./claimIndemnity.vue?vue&type=script&lang=js&"
import style0 from "./claimIndemnity.vue?vue&type=style&index=0&id=4d028889&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d028889",
  null
  
)

export default component.exports